import { useEffect } from "react";

// This hook repositions the Google logo on the map to avoid overlap with Leaflet controls..
export function useGoogleLogoPosition() {
    useEffect(() => {
        // Try multiple times to ensure logo is found and moved
        const checkInterval = setInterval(() => {
            const logoElement = document.querySelector('[title="Open this area in Google Maps (opens a new window)"]');
            if (logoElement) {
                const logoContainer = logoElement.closest('div');
                if (logoContainer) {
                    // Move it up and to the right
                    logoContainer.style.bottom = '0px';
                    logoContainer.style.left = '40px';
                    logoContainer.style.right = 'auto';
                    clearInterval(checkInterval);
                }
            }
        }, 100);

        // Clear interval after 3 seconds
        setTimeout(() => clearInterval(checkInterval), 3000);

        return () => clearInterval(checkInterval);
    }, []);
}
